export default __webpack_public_path__ + "static/media/trader_pro.c185bc28.png";